let config={
  //配置首页静态内容
  friendly:[
    {href:'http://www.moe.edu.cn/', name:'教育部网站'},
    {href:'http://www.moe.edu.cn/s78/A10/', name:'教育部教师工作司'},
    {href:'http://www.ougz.edu.cn/', name:'广州市广播电视大学'},
    {href:'http://southteacher.com/', name:'南方教师在线'}
  ],
  headerTop:{
    href:'http://jx.southteacher.com/',
    name:'江西省中小学幼儿园教师培训',
    hotTel:'4000-900-180'
  },
  headerLogo:{src:'https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=e7ef61acdf2d47a193da6fc3a7ef4184'},
  footerInfo:'<p>\n' +
    '        <span>粤ICP备14093666号-2  ©2018 广州广播电视大学</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n' +
    // '        <span>指导单位：广州市教育评估和教师继续教育指导中心</span>\n' +
    '      </p>\n' +
    '      <p>\n' +
    // '        <span>承办方：ee教育  |  广州远程教育中心</span>&nbsp;&nbsp;&nbsp;&nbsp;\n' +
    // '        <span>©2016</span>&nbsp;&nbsp;&nbsp;&nbsp;\n' +
    // '        <span>增值电信业务经营许可证编号粤B2-20042063  |  粤ICP备08131364号</span>\n' +
    // '      </p>\n' +
    // '      <p>\n' +
    '        <span>服务邮箱：4000900180@gzedu.net &nbsp;&nbsp; | &nbsp;&nbsp; 教育服务热线：4000900180</span>\n' +
    '      </p>',
  trackMain:[
    {href:'http://www.gzteacher.com/', name:'广州市中小学教师继续教育网'},
    {href:'http://yx.gzedu.com/', name:'广州市中小学教师网络研修社区'},
    {href:'http://www.gzehome.com/default.php', name:'广州市教师e家'}
  ],
  hotTel:'400-009-6930',
  //配置培训统计静态内容
  appName:'宜春市中小学教师信息技术应用能力提升工程2.0',
  //配置学校广场静态内容
  squareBgHeader:{src:'https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=72481dbe2a0c474b82e8e986b456d51a'},
  squareFooterBg:{src:'https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=ce7afba082b14083b7297564e33ba9a3'},
  defaultPic:{src:'https://file.gzteacher.com/upload/downloadFile.do?uploadInfoId=c332ecae6ae647f08e21925376023579'},
  areaList:[
    {area:'越秀区',
      school:[
           {name:'广州市越秀区实验小学1',code:1},
           {name:'广州市越秀区实验小学2',code:2},
           {name:'广州市越秀区实验小学3',code:3}
      ]
    },
    {area:'白云区',
      school:[
        {name:'广州市白云区实验小学1',code:1},
        {name:'广州市白云区实验小学2',code:2},
        {name:'广州市白云区实验小学3',code:3}
      ]
    }, {area:'荔湾区',
      school:[
        {name:'广州市荔湾区实验小学1',code:1},
        {name:'广州市荔湾区实验小学2',code:2},
        {name:'广州市荔湾区实验小学3',code:3}
      ]
    },
    {area:'天河区',
      school:[
        {name:'广州市天河区实验小学1',code:1},
        {name:'广州市天河区实验小学2',code:2},
        {name:'广州市天河区实验小学3',code:3}
      ]
    }
  ]
};

export default config;



// WEBPACK FOOTER //
// ./src/core/config.js